import React, { useState, useEffect, useMemo } from 'react'
import StepItem from '../../molecules/StepItem/StepItem'
import { Formik } from 'formik'
import Credenziali from './steps/Credenziali/Credenziali'
import Autorizzazioni from './steps/Autorizzazioni/Autorizazzioni'
import { getValidationSchema } from './validationSchema'
import Button from '../../atoms/Button/Button'
import { api } from '../../../utils/index'
import { useRouter } from 'next/router'
import { REGISTRAZIONESG, REGISTRAZIONECHECK } from '../../../utils/endpoint'
import useTrans from '../../../hooks/useTrans'
import usePrivacy from '../../../hooks/usePrivacy'
import { useSelector } from 'react-redux'
import TipologiaUtente from './steps/TipologiaUtente/TipologiaUtente'
import DatiSpedizioneFatturazione from './steps/DatiSpedizioneFatturazione/DatiSpedizioneFatturazione'
import { getTipologieUtenteRegistrazione, isStepRequired } from '../../../utils/servicegift'
import Alert from '../../atoms/Alert/Alert'
import { getDataCheckRegistrazioneSg, getDataRegistrazioneSg } from '../../../utils/registrazioneSg'

const FormRegistrazioneSg = () => {
  const { service_gift } = useSelector((state) => state?.servicegift)
  const router = useRouter()
  const t = useTrans()

  const { social } = router.query
  const [errors, setErrors] = useState([])
  const [step, setStep] = useState(0)
  const [tipologiaUtenteChiave, setTipologiaUtenteChiave] = useState(
    getTipologieUtenteRegistrazione(service_gift)?.[0]?.chiave
  )
  const validationSchema = getValidationSchema(tipologiaUtenteChiave, social !== undefined)

  const visibileSteps = useMemo(() => {
    return [
      'tipologia',
      'credenziali',
      'dati_fatturazione_spedizione',
      'autorizzazioni',
    ].filter((x) => isStepRequired(service_gift, tipologiaUtenteChiave, 'registrazione', x))
  }, [service_gift, tipologiaUtenteChiave])

  const stepsDetails = {
    tipologia: {
      placeholder: t('Tipologia di utente'),
      component: TipologiaUtente,
    },
    credenziali: {
      placeholder: social
        ? t('Informazioni personali')
        : t('Credenziali di accesso e informazioni personali'),
      component: Credenziali,
    },
    dati_fatturazione_spedizione: {
      placeholder: t('Dati fatturazione e spedizione'),
      component: DatiSpedizioneFatturazione,
    },
    autorizzazioni: {
      placeholder: t('Autorizzazioni e consensi'),
      component: Autorizzazioni,
    },
  }

  useEffect(() => {
    setErrors([])
  }, [step])

  const _postPayload = (values) => {
    const params = getDataRegistrazioneSg(values)

    return api.post(
      `${REGISTRAZIONESG}?lang=${router.locale}${social ? '&social=true' : ''}`,
      params
    )
  }

  const RenderStep = ({ props }) => {
    const t = useTrans()

    const { getUrlCondizioniGenerali } = usePrivacy()

    return (
      <>
        {visibileSteps.map((stepChiave, i) => {
          const FormComponent = stepsDetails[stepChiave].component
          return (
            <StepItem
              key={`step-${tipologiaUtenteChiave}-${stepChiave}`}
              stepNumber={i + 1}
              placeholder={stepsDetails[stepChiave].placeholder}
              setStep={setStep}
              Modificabile={step > i ? true : false}
              isDisabled={step < i ? true : false}
              open={step === i ? true : false}
            >
              <FormComponent
                step={step}
                setStep={setStep}
                props={props}
                setTipologiaUtente={setTipologiaUtenteChiave}
                getUrlCondizioniGenerali={getUrlCondizioniGenerali}
                social={social !== undefined}
              />
            </StepItem>
          )
        })}
      </>
    )
  }

  const handleEmailPiva = async (data, values) => {
    const { exists_email, exists_piva, exists_username } = data

    setErrors([
      ...(exists_email ? [t('Esiste già un account con la stessa Email')] : []),
      ...(exists_piva ? [t('Esiste già un account con la stessa Partita Iva')] : []),
      ...(exists_username ? [t('Esiste già un account lo username indicato')] : []),
    ])

    !exists_email &&
      !exists_username &&
      !exists_piva &&
      (await _postPayload(values)
        .then((res) => {
          const { success } = res.data
          if (success) {
            if (!service_gift?.autorizza_registrati && router?.query?.next) {
              // utente è già loggato, posso rediregere a query.next
              window.location.href = router.query.next
            } else {
              router.push('/myaccount/registrazione/completed')
            }
          } else {
            setErrors([
              t("C'è stato un errore durante la registrazione. Ti invitiamo a riprovare più tardi"),
            ])
          }
        })
        .catch((err) => {
          setErrors([
            t("C'è stato un errore durante la registrazione. Ti invitiamo a riprovare più tardi"),
          ])
        }))
  }

  if (!service_gift) {
    return null
  }

  return (
    <Formik
      validateOnBlur
      validateOnChange={true}
      validationSchema={validationSchema}
      isInitialValid={false}
      enableReinitialize
      initialValues={{
        utente: {
          tipologia: tipologiaUtenteChiave,
          email: null,
          nome: null,
          cognome: null,
          telefono: null,
          username: null,
          password: null,
          conferma_password: null,
        },
        /* credenziali: {
          username: null,
          password: null,
          conferma_password: null,
        }, */
        autorizzazioni: {
          privacy: false,
          privacy_commerciale: false,
        },
        /* dati_aziendali: {
          withProvincia: false,
        }, */
        dati_indirizzo: {},
        dati_indirizzo_spedizione: {},
        indirizzi_diversi:
          isStepRequired(
            service_gift,
            tipologiaUtenteChiave,
            'registrazione',
            'indirizzo_spedizione'
          ) &&
          !isStepRequired(
            service_gift,
            tipologiaUtenteChiave,
            'registrazione',
            'indirizzo_fatturazione'
          )
            ? true // valore iniziale a true se c'è indirizzo spedizione ma non quello di fatturazione
            : false,
        is_fatturazione_italia: false,
        is_spedizione_italia: false,
      }}
      onSubmit={(values) => {
        try {
          const params = getDataCheckRegistrazioneSg(values)
          api
            .get(REGISTRAZIONECHECK, { params })
            .then((res) => {
              setErrors([])
              handleEmailPiva(res.data, values)
            })
            .catch((error) => console.log(error, 'error p.iva'))
        } catch (error) {
          console.log(error)
        }
      }}
    >
      {(props) => (
        <>
          {!visibileSteps?.includes('tipologia') && (
            <div className="registrazione__template__tipologia-discalaimer">
              {getTipologieUtenteRegistrazione(service_gift)?.length > 0 ? (
                <p>
                  {t('La registrazione sul sito {0} è consentita esclusivamente per {1}', [
                    service_gift.nome,
                    t(getTipologieUtenteRegistrazione(service_gift)?.[0]?.titolo),
                  ])}
                </p>
              ) : (
                <p>
                  {t('La registrazione sul sito {0} è al momento disabilitata', [
                    service_gift.nome,
                  ])}
                </p>
              )}
            </div>
          )}
          {service_gift?.autorizza_registrati && (
            <div className="registrazione__template__alert-autorizza-registrati">
              <Alert placeholder="gli utenti non verranno abilitati subito" variant="error" />
            </div>
          )}
          <RenderStep props={props} />
          <>
            {errors.map((erorr, index) => (
              <div
                style={{ color: 'red', fontSize: 14, marginTop: 10, marginBottom: 10 }}
                key={index + '_error'}
              >
                <p>{erorr}</p>
              </div>
            ))}
          </>
          {step > visibileSteps.length - 1 &&
            props.isValid &&
            (errors.length ? (
              <Button
                type="submit"
                onClick={() => router.push('/myaccount/recupera-password')}
                label={t('Recupera Password')}
                size="medium"
                // variant="primary"
                className="registrazione__template__submit"
              />
            ) : (
              <Button
                type="submit"
                disabled={!props.isValid}
                onClick={() => props.handleSubmit()}
                label={t('Conferma registrazione')}
                size="medium"
                variant="primary"
                className="registrazione__template__submit"
              />
            ))}
        </>
      )}
    </Formik>
  )
}

export default FormRegistrazioneSg
